let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gYq2J")).then(() => parcelRequire('gxD3N'));